import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { verifiedState, xlsxSettings, xlsxcolumns, formatPercentReturn } from "./utils";
import {
  isMobile,
  formatPhone,
  currencyValue,
  isCmApprover,
  isDmApprover,
  isAllApprover,
  isVerifierUser,
} from "utils/common";
import { TablePagination } from "../common/desktopDataTable/tablePagination";
import { useSortableTable } from "../common/desktopDataTable/useSortableTable";
import MobileDataTable from "common/mobileDataTable";
import { TableTitle } from "../common/desktopDataTable/tableTitle";
import Header from "../common/desktopDataTable/header";
import { DataRows } from "../common/desktopDataTable/dataRows";
import alertIcon from "svg/red-alert-icon.svg";
import { SelectAll } from "store/laborTable/actionCreator";
import CustomTooltip from "common/tooltip";
import Button from "react-bootstrap/Button";
import { statusCard } from "../common/statusCard";
import { storeCard } from "../common/storeCard";
import "../common/mobileDataTable/style.scss";
import "../common/desktopDataTable/style.scss";
export const LaborTableDataTable = (props) => {
  const {
    tableBody,
    tableHeader,
    displaySearchFilter,
    searchFilterValue,
    handleSearchFilter,
    filteredTableList,
    handleCustomerRowSelection,
    isSelectAllChecked,
    handleActions,
    handleVerifyBtn,
    handleApproveBtn,
    handleRejectBtn,
    pendingPriceTabHeader,
    pendingXlsxcolumns,
    fcNaXLSXcolumns,
    showApprovalButtons,
    setShowApprovalButtons,
    expandedItems,
  } = props;

  const { fcRole, storeCcn, district, personID } = useSelector((state) => state.loggedInUser);
  const [currentPageButton, setCurrentPageButton] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const dispatch = useDispatch();
  const numberOfPages = [];
  const indexOfLastPost = currentPageButton * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  let filteredList;
  if (!filteredTableList) {
    filteredList = [];
  } else {
    filteredList = [...filteredTableList];
  }
  const { items, filteredItems, requestSort, sortConfig } = useSortableTable(tableBody, filteredList);
  let tableData = searchFilterValue && searchFilterValue !== "" && searchFilterValue.length > 0 ? filteredItems : items;
  let currentData = displaySearchFilter ? [] : [...tableData];
  let howManyPages = 0;
  let pendingPriceTabList = tableData?.filter((col) => col?.approvalStatus == "PENDING");
  if (fcRole == "FcCityMgr") {
    pendingPriceTabList = pendingPriceTabList.filter((col) => col?.cmgrGemsId == personID);
  }

  const defaultToPendingPriceTab =
    (fcRole == "FcDistrictMgr" || fcRole == "FcCityMgr") && pendingPriceTabList.length > 0;
  const [pricesTab, setPricesTab] = useState(defaultToPendingPriceTab ? "Pending" : "All");
  setShowApprovalButtons(defaultToPendingPriceTab);

  if (pricesTab === "Pending") {
    currentData = pendingPriceTabList && pendingPriceTabList.slice(indexOfFirstPost, indexOfLastPost);
    if (pendingPriceTabList) {
      howManyPages = Math.ceil(pendingPriceTabList.length / postsPerPage);
    }
  } else {
    currentData = tableData && tableData.slice(indexOfFirstPost, indexOfLastPost);
    if (tableData) {
      howManyPages = Math.ceil(tableData.length / postsPerPage);
    }
  }
  for (let i = 1; i <= howManyPages; i++) {
    numberOfPages.push(i);
  }
  const handleApproveAction = (action, isMobile, row) => {
    if (action === "approve") {
      handleApproveBtn(isMobile, row);
    } else if (action === "reject") {
      handleRejectBtn(isMobile, row);
    }
  };
  const handleCheckboxSelection = (laborCodeStoreId, row) => {
    handleCustomerRowSelection(laborCodeStoreId, row);
    allowApprovals(row);
  };

  const exportLaborTable = async () => {
    const { default: xlsx } = await import("json-as-xlsx");
    xlsx(xlsxData, xlsxSettings);
  };

  const handleSelectAll = (e) => {
    if (pricesTab === "Pending") {
      for (let row of pendingPriceTabList) allowApprovals(row);
      dispatch(SelectAll(pendingPriceTabList));
    } else {
      dispatch(SelectAll(tableData));
    }
  };
  const handleRowSelect = (arg1, arg2) => {
    if (arg2 != null) {
      handleCheckboxSelection(arg1, arg2);
    } else {
      handleSelectAll(arg1);
    }
  };
  const allowApprovals = (row) => {
    let allow = true;
    if (isDmApprover(fcRole) || isAllApprover(fcRole)) {
      allow = isAllApprover(fcRole) || row.district == district;
    } else if (isCmApprover(fcRole)) allow = row.cmgrGemsId == personID;
    else allow = false;

    setShowApprovalButtons(allow);
  };

  const selectPricingTabSection = () => {
    return (
      <div className="custom-tabs">
        <div className="d-flex custom-tabs__nav nav nav-pills">
          <div className="d-flex nav-item">
            <Button
              className={`nav-link ${pricesTab === "All" ? "active" : ""}`}
              onClick={() => {
                setPricesTab("All");
              }}
            >
              All Prices
            </Button>
          </div>
          <div className="d-flex nav-item">
            <Button
              className={`nav-link ${pricesTab === "Pending" ? "active" : ""}`}
              onClick={() => {
                setPricesTab("Pending");
              }}
            >
              Pending Price Approvals &nbsp;
              <span className="pending_count ">{pendingPriceTabList.length}</span>
            </Button>
          </div>
        </div>
        <hr className="m-0" />
      </div>
    );
  };
  let xlsxData = [
    {
      columns: pricesTab === "Pending" ? pendingXlsxcolumns : fcRole === "FcNA" ? fcNaXLSXcolumns : xlsxcolumns,
      content: pricesTab === "All" ? [...tableData] : [...pendingPriceTabList],
    },
  ];

  const renderDataTableRows = () => {
    const tempTableHeader = pricesTab === "Pending" ? pendingPriceTabHeader : tableHeader;
    return currentData.map((row) => {
      const { storeNbr, exceptionPrice, laborCodeStoreId, isSelected, nam, addr, city, str, zip, phone, contact } = row;

      const canEditStorePrice = ["FcStoreManager", "FcOpsMgr", "FcSuperAdmin"].includes(fcRole);
      const canEditExceptionPrice = fcRole === "FcSalesRep";
      const canEdit = storeCcn === storeNbr && (canEditStorePrice || (canEditExceptionPrice && exceptionPrice === "1"));

      return (
        <tr key={laborCodeStoreId} className="table-root__body__tr" style={{ lineHeight: "19px" }}>
          {tempTableHeader.map((col, index) => {
            return (
              <>
                {col.name === "Checkbox" && (
                  <td
                    className="table-root__body__tr__td table-root__body__tr__td__checkbox table-root__body__tr__td__fixed-row"
                    key={index}
                  >
                    <input
                      type="checkbox"
                      aria-label="Checkbox selection of rows"
                      className="table-root__body__tr__td__checkbox--input"
                      checked={isSelected}
                      onChange={() => handleRowSelect(laborCodeStoreId, row)}
                    />
                  </td>
                )}

                {col.name === "Store No" && (
                  <td
                    className="table-root__body__tr__td table-root__body__tr__td__text mobile-data__row__column__item__top__left__name--text hover_style"
                    key={index}
                  >
                    <CustomTooltip
                      placement="top"
                      trigger="hover"
                      text={storeCard(
                        storeNbr,
                        nam,
                        addr,
                        city,
                        str,
                        zip,
                        formatPhone(phone),
                        contact,
                        row.verificationTime,
                      )}
                    >
                      <span>
                        {verifiedState(row.verificationTime)}&nbsp;
                        {storeNbr}
                      </span>
                    </CustomTooltip>
                  </td>
                )}

                {col.name === "Bill Rates($)" && (
                  <td
                    className="table-root__body__tr__td table-root__body__tr__td__text mobile-data__row__column__item__top__left__name--text"
                    key={index}
                  >
                    {parseFloat(row.laborBillRate) === parseFloat(row.installerPayRate) ? (
                      <CustomTooltip placement="top" trigger="hover" text={"Bill Rate is same as Installer Pay Rate"}>
                        <span className="hover_style">{currencyValue(row.laborBillRate)}</span>
                        <span>
                          <img className="alert_style" src={alertIcon} />
                        </span>
                      </CustomTooltip>
                    ) : (
                      displayRowItem(row, col)
                    )}
                  </td>
                )}

                {col.name === "Labor Code" && (
                  <td
                    className={`table-root__body__tr__td table-root__body__tr__td__text mobile-data__row__column__item__top__left__name--text${canEdit ? " customer-txt" : ""}`}
                    key={index}
                  >
                    {canEdit ? (
                      <Button
                        variant="link"
                        className="text-decoration-none p-0 d-inline-flex align-items-center"
                        onClick={() => handleActions(row)}
                      >
                        {`${row.laborCode}- ${row.laborCodeDesc}`}
                      </Button>
                    ) : (
                      <span>{`${row.laborCode}- ${row.laborCodeDesc}`}</span>
                    )}
                  </td>
                )}

                {col.name === "Account Name" && (
                  <td className="table-root__body__tr__td table-root__body__tr__td__text" key={index}>
                    <CustomTooltip placement="top" trigger="hover" text={`${row.accountName}`}>
                      <span>{row.accountName}</span>
                    </CustomTooltip>
                  </td>
                )}

                {col.name === "Job" && (
                  <td className="table-root__body__tr__td table-root__body__tr__td__text" key={index}>
                    <CustomTooltip placement="top" trigger="hover" text={`${!row.jobName ? "N/A" : row.jobName}`}>
                      <span>{row.jobNumber}</span>
                    </CustomTooltip>
                  </td>
                )}

                {col.name === "Status" && (
                  <td key={index} style={{ lineHeight: "15px" }}>
                    <CustomTooltip
                      placement="top"
                      trigger="hover"
                      text={statusCard(
                        row.approvalStatus,
                        currencyValue(
                          row.approvalStatus === "PENDING" || row.approvalStatus === "REJECTED"
                            ? row.laborBillRateNew
                            : row.laborBillRate,
                        ),
                        currencyValue(
                          row.approvalStatus === "PENDING" || row.approvalStatus === "REJECTED"
                            ? row.installerPayRateNew
                            : row.installerPayRate,
                        ),
                        formatPercentReturn(
                          row.approvalStatus === "PENDING" || row.approvalStatus === "REJECTED"
                            ? row.laborBillRateNew
                            : row.laborBillRate,
                          row.approvalStatus === "PENDING" || row.approvalStatus === "REJECTED"
                            ? row.installerPayRateNew
                            : row.installerPayRate,
                        ),
                      )}
                    >
                      <span
                        style={{ fontSize: "10px" }}
                        className={`table-root__body__tr__td__dotstyle${
                          row.approvalStatus === "APPROVED"
                            ? "--approved-dot"
                            : row.approvalStatus === "PENDING"
                              ? "--pending-dot"
                              : row.approvalStatus === "INITIALIZE"
                                ? "--initialize-dot"
                                : row.approvalStatus === "REJECTED"
                                  ? "--reject-dot"
                                  : ""
                        }`}
                      >
                        &#11044;
                      </span>
                      <span className="table-root__body__tr__td table-root__body__tr__td__text mobile-data__row__column__item__top__left__name--text hover_style">
                        {row.approvalStatus}
                      </span>
                    </CustomTooltip>
                  </td>
                )}
                {col.name !== "Status" &&
                  col.name !== "Labor Code" &&
                  col.name !== "Store No" &&
                  col.name !== "Checkbox" &&
                  col.name !== "Account Name" &&
                  col.name !== "Bill Rates($)" &&
                  col.name !== "Job" && (
                    <td className="table-root__body__tr__td table-root__body__tr__td__text" key={index}>
                      {displayRowItem(row, col)}
                    </td>
                  )}
              </>
            );
          })}
        </tr>
      );
    });
  };
  const displayRowItem = (row, col) => {
    if (row && col && col.dataKey && row[col.dataKey]) {
      if (
        col.name &&
        (col.name === "Bill Rates($)" ||
          col.name === "Installer Pay Rate" ||
          col.name === "New Bill Rates($)" ||
          col.name === "New Installer Pay Rate" ||
          col.name === "Old Price")
      ) {
        return currencyValue(row[col.dataKey]);
      } else {
        return row[col.dataKey];
      }
    }
  };
  const displayMobileRowItem = (row, item) => {
    if (row && item && item.dataKey && row[item.dataKey]) {
      if (
        item &&
        item.name &&
        (item.name === "Unit Price" ||
          item.name === "Extended Price" ||
          item.name === "Sales Tax" ||
          item.name === "Total" ||
          item.name === "Old Price" ||
          item.name === "Updated Price")
      ) {
        return currencyValue(row[item.dataKey]);
      } else if (item.name === "salesNumber" && !item.dataKey && !row[item.dataKey]) {
        return "N/A";
      } else {
        return row[item.dataKey];
      }
    }

    if (item && item.keyName && item.keyName === "Store No") {
      return (
        <CustomTooltip
          placement="top"
          trigger="click"
          text={storeCard(
            row[item.valueName],
            row[item.nm],
            row[item.addr],
            row[item.city],
            row[item.st],
            row[item.zip],
            formatPhone(row[item.phone]),
            row[item.contact],
            row[item.verificationTime],
          )}
        >
          {verifiedState(row[item.verificationTime])}
          {row[item.valueName]}
        </CustomTooltip>
      );
    } else if (item && item.keyName && item.keyName === "Approval Status") {
      return (
        <CustomTooltip
          placement="top"
          trigger="click"
          text={statusCard(
            row[item.valueName],
            currencyValue(
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.laborRateNew]
                : row[item.laborBillRate],
            ),
            currencyValue(
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.installerRateNew]
                : row[item.installerPayRate],
            ),
            formatPercentReturn(
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.laborRateNew]
                : row[item.laborBillRate],
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.installerRateNew]
                : row[item.installerPayRate],
            ),
          )}
        >
          {row[item.valueName]}
        </CustomTooltip>
      );
    } else if (item && item.keyName && item.keyName === "Labor Code") {
      return (
        <CustomTooltip
          placement="top"
          trigger="click"
          text={`${row[item.valueName1]}- ${row[item.valueName2]}: ${row[item.valueName3]}`}
        >
          {`${row[item.valueName1]}- ${row[item.valueName2]}`}
        </CustomTooltip>
      );
    } else if (item && item.keyName && item.keyName === "Product Name") {
      return (
        <CustomTooltip placement="top" trigger="click" text={row[item.valueName]}>
          {row[item.valueName]}
        </CustomTooltip>
      );
    } else if (item && item.keyName && item.keyName === "Description" && isBulkUpdateLabor) {
      return (
        <CustomTooltip placement="top" trigger="click" text={row[item.valueName]}>
          {row[item.valueName]}
        </CustomTooltip>
      );
    } else if (
      item &&
      item.keyName &&
      (item.keyName === "Bill Rates($)" ||
        item.keyName === "Installer Pay Rate" ||
        item.keyName === "New Bill Rates($)" ||
        item.keyName === "New Installer Pay Rate" ||
        item.keyName === "Updated Price" ||
        item.keyName === "Old Price")
    ) {
      return currencyValue(row[item.valueName]);
    } else if (item.valueName && row[item.valueName]) {
      return row[item.valueName];
    } else {
      return "";
    }
  };

  return (
    <div className="search-table-wrapper">
      <div className="container-fluid search-table">
        {(isCmApprover(fcRole) || isDmApprover(fcRole) || isAllApprover(fcRole)) && selectPricingTabSection()}
        {
          <TableTitle
            displaySearchFilter={displaySearchFilter}
            countTitle={"Search Results"}
            searchResultsLength={pricesTab === "Pending" ? pendingPriceTabList.length : tableData.length}
            searchFilterValue={searchFilterValue}
            handleSearchFilter={handleSearchFilter}
          />
        }
        <div className="section-three">
          <div className="d-flex justify-content-between section-three__root flex-column flex-md-row">
            {isVerifierUser(fcRole) ? (
              <div className="d-flex">
                <Button variant="outline-primary" onClick={() => handleVerifyBtn(false)}>
                  Verify Current Rates
                </Button>
              </div>
            ) : showApprovalButtons && pricesTab === "Pending" ? (
              <div className="d-flex ">
                <div className="section-three__root__btn mx-0">
                  <div className="section-three__root__btn__common">
                    <Button
                      className={`section-three__root__btn__common__btn ${
                        showApprovalButtons
                          ? "section-three__root__btn__approve__btn--active"
                          : "section-three__root__btn__approve__btn--inactive"
                      }`}
                      disabled={!showApprovalButtons}
                      onClick={() => handleApproveBtn(false)}
                    >
                      <span className="section-three__root__btn__common__btn--text">Approve</span>
                    </Button>
                  </div>
                </div>
                <div className="section-three__root__btn">
                  <div className="section-three__root__btn__common">
                    <Button
                      className={`section-three__root__btn__common__btn ${
                        showApprovalButtons
                          ? "section-three__root__btn__reject__btn--active"
                          : "section-three__root__btn__reject__btn--inactive"
                      }`}
                      disabled={!showApprovalButtons}
                      onClick={() => handleRejectBtn(false)}
                    >
                      <span className="section-three__root__btn__common__btn--text">Reject</span>
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex"></div>
            )}

            <div className="d-flex">
              <Button variant="outline-primary" onClick={exportLaborTable}>
                Export Labor Table
              </Button>
            </div>
          </div>
        </div>
        {isMobile() && (
          <MobileDataTable
            expandedItems={expandedItems}
            sorting={sortConfig}
            onSorting={(field) => requestSort(field)}
            currentData={pricesTab === "Pending" ? pendingPriceTabList : tableData}
            parentComponent={"laborTable"}
          />
        )}
        <div className="table-responsive customer-search__table">
          <table id="example" className="table table-root">
            <Header
              tableHeader={pricesTab === "Pending" ? pendingPriceTabHeader : tableHeader}
              handleSelectAll={handleRowSelect}
              isSelectAllChecked={isSelectAllChecked}
              sorting={sortConfig}
              onSorting={(field) => requestSort(field)}
              isSearchTable={true}
              isLaborTable={true}
              parentComponent={"laborTable"}
            />
            <DataRows
              displaySearchFilter={true}
              currentData={currentData}
              renderRows={renderDataTableRows}
              errorFlag={false}
            />
          </table>
        </div>
        <div className={"section-three"}>
          <div className="d-flex justify-content-between section-three__root">
            <TablePagination
              numberOfItems={pricesTab === "Pending" ? pendingPriceTabList.length : tableData.length}
              currentPageButton={currentPageButton}
              setCurrentPageButton={setCurrentPageButton}
              postsPerPage={postsPerPage}
              setPostsPerPage={setPostsPerPage}
              numberOfPages={numberOfPages}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
